module.exports = __webpack_public_path__ + "media/ring.eee14ea6.mp3";